import {dashboardApi} from 'sources/api';
import urlWithParams from 'utils/urlWithParams';
import {Map} from 'immutable';
import CoachingEffectivenessReport from 'records/CoachingEffectivenessReport';

const ManagerCoachingEffectivenessSource = {
  getCoachingEffectivenessReport(widgetConfig, managerId) {
    if (managerId) {
      const url = urlWithParams('widget', {managerId});
      return dashboardApi.postJson(url, widgetConfig).then(response => makeImmutable(response));
    } else {
      return dashboardApi
        .postJson('widget', widgetConfig)
        .then(response => makeImmutable(response));
    }
  },
};

function makeImmutable(response) {
  const map = Map(response);
  // TODO handle error widget somehow.
  const report = Map(map.get('report')).mapEntries(([userId, rawReport]) => [
    userId,
    new CoachingEffectivenessReport(rawReport),
  ]);
  return map.set('report', report);
}

export default ManagerCoachingEffectivenessSource;
